export function getBoatPrice(product: any): number {
  return Number(product?.additionalInfo?.totalPrice) || 0;
}

export function getBoatCurrency(product: any): string {
  return product?.additionalInfo?.currency;
}

export function getBoatLogo(product: any): string {
  return product?.logo || product?.additionalInfo?.logo || '';
}

export function getBoatDiscountPercentage(product: any): number {
  return Number(product?.additionalInfo?.pricing?.discount?.percentage) || 0;
}

export function getBoatCoverImage(product: any): string {
  const images = product?.additionalInfo?.images || [];
  const cover = images.find((image: any) => image.is_cover === 1) || images[0];
  return cover?.thumbnail || '/assets/img/app/hotel_default.png';
}
